/** Personnalisation org BL-0606 (initLU U3129/U3130, etc.). */
export type U2000HourBankLegacyPersonalization = {
  skipHourBankBalanceValidationOnSubmit?: boolean;
};

/** true = org legacy : pas de garde-fou UI soldes banques à la soumission FT. */
export function u2000SkipHourBankBalanceValidationOnSubmit(
  personalization?: U2000HourBankLegacyPersonalization | null,
): boolean {
  return personalization?.skipHourBankBalanceValidationOnSubmit === true;
}
